/**
 *
 * Function for The Footer Nav (JS)
 *
 * @author Yusuke Manabe @ Space-Time Inc.
 * @version 2020-10-01
 *
 *
 */


(function() {
	const footerMenuElement    = document.getElementsByClassName('site-footer-nav')[0];

	const liElements = footerMenuElement.querySelectorAll('.menu > li');
	for (let i = 0; i < liElements.length; i++) {
		if (i < liElements.length / 2) {
			liElements[i].style.gridColumn = 1;
		} else {
			liElements[i].style.gridColumn = 2;
		}
	}


}());
